import normalize from 'json-api-normalizer';

export default class Graph {
	static from (jsonapi) {
		let key = 'graphs'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Graph.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Graph.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi) {
		const { id, attributes } = jsonapi;
		return new Graph ( Object.assign({id: id}, attributes) );
	}

	constructor ({ id, title, maxY, dataPoints, legend, colour, graphThresholds }) {
		this.id           = id ? id : -1;
		this.title        = title ? title : null;
		this.max_y		  = maxY ? maxY : 0;
		this.data_points  = dataPoints ? dataPoints : {};
		this.legend		  = legend ? legend : null;
		this.colour		  = colour ? colour : "#000000"
    this.graph_thresholds =  graphThresholds ? graphThresholds : {};
	}

}
